import { observer } from 'mobx-react-lite';
import styled from 'styled-components';

import { FiftyLogo } from '@components/icons/fifty-logo';
import { LottieAnimation } from '@components/lottie-animation';
import { LeftContentRightBrandedPage } from '@components/page-containers/page-containers';
import { theme } from '@styles/theme';
import { pxToRem } from '@utils/converters';

export const UnauthedPage = observer(({ children }) => {
  return (
    <LeftContentRightBrandedPage
      branded={
        <BrandedContainer>
          <LogoContainer>
            <FiftyLogo size={144} color="indigo5" />
          </LogoContainer>
          <LottieAnimation animation="journeys-logo" delay={1500} />
        </BrandedContainer>
      }
    >
      <ContentContainer>{children}</ContentContainer>
    </LeftContentRightBrandedPage>
  );
});

const LogoContainer = styled.div({
  position: 'absolute',
  top: pxToRem(-16),
  right: pxToRem(40),
});

const BrandedContainer = styled.div({
  backgroundColor: theme.color.indigo400,
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const ContentContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '100vh',
  '> div': {
    width: pxToRem(448),
    justifyContent: 'center',
  },
});
